import queryString from "query-string";

export const COLUMN_MAPPING_TAB_PARAM = "tab";
export const STAGING_VIEW_PARAM = "stagingView";
export const PARENT_TAB_STAGING = "staging";
export const PARENT_TAB_MAPPING = "mapping";
export const STAGING_VIEW_RULES = "rules";
export const STAGING_VIEW_GRID = "grid";

const RULES_GRID_PARAMS = ["filter", "page", "pageSize", "sort"];

export const getParentTabFromSearch = (search) => {
    const query = queryString.parse(search || "");
    return query[COLUMN_MAPPING_TAB_PARAM] === PARENT_TAB_STAGING
        ? PARENT_TAB_STAGING
        : PARENT_TAB_MAPPING;
};

export const getStagingViewFromSearch = (search) => {
    const query = queryString.parse(search || "");
    return query[STAGING_VIEW_PARAM] === STAGING_VIEW_RULES
        ? STAGING_VIEW_RULES
        : STAGING_VIEW_GRID;
};

export const setParentTabInSearch = (search, tab) => {
    const query = queryString.parse(search || "");
    if (tab === PARENT_TAB_STAGING) {
        query[COLUMN_MAPPING_TAB_PARAM] = PARENT_TAB_STAGING;
    } else {
        delete query[COLUMN_MAPPING_TAB_PARAM];
        delete query[STAGING_VIEW_PARAM];
        RULES_GRID_PARAMS.forEach((key) => delete query[key]);
    }
    return queryString.stringify(query);
};

export const setStagingViewInSearch = (search, view) => {
    const query = queryString.parse(search || "");
    query[COLUMN_MAPPING_TAB_PARAM] = PARENT_TAB_STAGING;
    if (view === STAGING_VIEW_RULES) {
        query[STAGING_VIEW_PARAM] = STAGING_VIEW_RULES;
    } else {
        delete query[STAGING_VIEW_PARAM];
    }
    RULES_GRID_PARAMS.forEach((key) => delete query[key]);
    return queryString.stringify(query);
};

export const clearRulesGridQuery = (search) => {
    const query = queryString.parse(search || "");
    RULES_GRID_PARAMS.forEach((key) => delete query[key]);
    return queryString.stringify(query);
};

export const resetRulesPage = (search) => {
    const query = queryString.parse(search || "");
    delete query.page;
    return queryString.stringify(query);
};
